"use client";

import type { ReactNode } from "react";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { stripLocaleFromPathname } from "@/lib/i18n/routing";

const ReduxProvider = dynamic(() => import("./redux-provider"));

export default function RouteScopedReduxProvider({
  children,
}: {
  children: ReactNode;
}) {
  const pathname = usePathname() ?? "/";
  const normalizedPathname = stripLocaleFromPathname(pathname).pathnameWithoutLocale;

  if (normalizedPathname === "/") {
    return <>{children}</>;
  }

  return <ReduxProvider>{children}</ReduxProvider>;
}
